import axios from "utils/axios";
import Cookies from "js-cookie";

const handleOidcSubmit = () => {
  window.oidcUserManager.signinRedirect({
    extraQueryParams: {
      identity_provider: "Local",
      slug: "Ogden",
    },
  });
};

const updateCustomerAuthLastLogoutDetails = async () => {
  let customerAuthId = Cookies.get("customer_auth_id");

  if (customerAuthId) {
    const payload = {
      customerAuthId: customerAuthId,
    };

    let axios_path_to =
      process.env.REACT_APP_BACK_END_SERVER_URL +
      "/server/v1/customers_auth/updateCustomerAuthLastLogoutDetails";

    await axios.post(axios_path_to, payload).then(
      (response) => {
        if (response.status === 200) {
          return true;
        } else {
          window.location.href = window.location.origin + "/auth/login";
          return false;
        }
      },
      (error) => {
        console.log(error);
        return false;
      }
    );
  }
};
const removeAllCookies = () => {
  Cookies.remove("bestofuserlevel");
  Cookies.remove("bestofphotouserlevel");
  Cookies.remove("ballot_name");
  Cookies.remove("guide_name");
  Cookies.remove("ballot_id");
  Cookies.remove("super_admin");
  Cookies.remove("customer_id");
  Cookies.remove("customer_email");
  Cookies.remove("customer_auth_id");
  Cookies.remove("owner");
  Cookies.remove("org_owner_id");
  Cookies.remove("show_org_nav");
  Cookies.remove("parent_customer_id");
  Cookies.remove("parent_customer_name");
  Cookies.remove("parent_bestofuseracct");
  Cookies.remove("bestofuseracct");

  Cookies.remove("stripe_connected_account_id");
  Cookies.remove("member_role");
  Cookies.remove("enable_winners_portal");
  Cookies.remove("connected_all_entries_to_google");

  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

  Cookies.remove("logged_using_fire_base");
  Cookies.remove("findOrgsBelongsToCalled");
  Cookies.remove("findBestOfOrgsBelongsToCalled");
};
async function handleOIDCLogout(e) {
  window.oidcUserManager.getUser().then((user) => {
    if (user) {
      window.oidcUserManager.removeUser();
      const returnUrl = encodeURIComponent(
        window.location.origin + "/auth/login"
      );
      const logoutUrl = `${process.env.REACT_APP_SSO_AUTHORITY}/account/logout?post_logout_redirect_uri=${returnUrl}`;

      window.location.href = logoutUrl;

      return 1;
    } else {
      window.location.href = window.location.origin + "/auth/login";

      return 1;
    }
  });
}
export default async () => {
  await updateCustomerAuthLastLogoutDetails();
  removeAllCookies();
  await handleOIDCLogout();
};
